import { BarChart, XAxis, YAxis, Bar, LabelList, Tooltip } from "recharts";
import { ONE_MINUTE_OF_MS, FORMAT_MONTH_DAY } from "reports/utils/timeUtils";
import { round } from "lodash";
import { format } from "date-fns";
import {
  getAxisTick,
  formatNamesTicks,
} from "../steris/utils/sterisChangeoverUtils";
import {
  renderCustomizedCenterTicks,
  renderCustomizedEndDemarkingTicks,
  renderCustomizedStartDemarkingTicks,
} from "../steris/ReportContent/SterisChart";
import styled from "styled-components/macro";
import RotatedYAxisLabel from "../../../components/Reports/RechartHelpers/RotatedYAxisLabel";
import { lightGrey } from "../../../constants/colors";
import { SegmentCategoryOrderType } from "../../../components/Reports/reportUtils";

const ChartStyles = styled.div`
  .onlyShowWhilePrinting {
    display: none;
  }
  @media print {
    .recharts-wrapper,
    .recharts-surface {
      width: 99% !important;
      height: 400px !important;
    }

    .onlyShowWhilePrinting {
      display: initial;
    }
  }
`;

export default function SterisDowntimeEventChart({
  title,
  data,
  width,
  color,
}: {
  title: string;
  data: SegmentCategoryOrderType[];
  width: number;
  color: string;
}) {
  const dataConvertedToMinutes = data.map(segment => {
    return {
      ...segment,
      duration: round(segment.duration / ONE_MINUTE_OF_MS, 0),
      date: format(segment.ge, FORMAT_MONTH_DAY),
    };
  });

  const ticks = formatNamesTicks(getAxisTick(dataConvertedToMinutes));
  const height = 800;

  const CustomTooltip = props => {
    const { label } = props;
    const tagItem = dataConvertedToMinutes.find(({ order }) => order === label);

    return (
      <div style={{ backgroundColor: lightGrey, padding: "1em" }}>
        <p>{`Machine: ${tagItem?.processName}`}</p>
        <p>{`Duration: ${tagItem?.duration} min`}</p>
      </div>
    );
  };

  return (
    <ChartStyles>
      <BarChart
        width={width}
        height={height}
        data={dataConvertedToMinutes}
        margin={{ top: 15, bottom: 0, left: 30, right: 5 }}
      >
        <XAxis dataKey="order" tickMargin={7} />
        {[
          { id: 1, tick: renderCustomizedCenterTicks },
          { id: 2, tick: renderCustomizedEndDemarkingTicks, label: true },
          { id: 3, tick: renderCustomizedStartDemarkingTicks },
        ].map(({ id, tick, label }) => {
          return (
            <XAxis
              key={id}
              dataKey="date"
              axisLine={false}
              tick={tick}
              ticks={ticks}
              interval={0}
              tickLine={false}
              xAxisId={id}
              label={label ? title : undefined}
            />
          );
        })}
        <Tooltip content={<CustomTooltip />} />
        <YAxis
          type="number"
          orientation="left"
          label={
            <RotatedYAxisLabel
              height={height - 50}
              value="Category Duration (min)"
            />
          }
        />
        <Bar dataKey="duration" fill={color} isAnimationActive={false}>
          <LabelList
            dataKey="processName"
            position="top"
            fill="black"
            offset={25}
            className="onlyShowWhilePrinting"
          />
          <LabelList
            dataKey="duration"
            position="top"
            fill="black"
            className="onlyShowWhilePrinting"
          />
        </Bar>
      </BarChart>
    </ChartStyles>
  );
}
